import { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useUser } from '../../hooks/use-user';
import useApiRequest from '../../lib/hooks/useRequest';
import { UserRole, UserType } from '../../lib/interfaces/user';
import DataFetchParent from '../../ui/components/ui/data-fetch';
import { DASHBOARD_KEY } from './constants/kpi.constants';
import KpiDashboardPage from './page';
import { KpiDashboardMetaResponseDto } from './types/response';

const KpiDashboardWrapper = () => {
  const { user } = useUser();
  const navigate = useNavigate();

  const { apiRequest } = useApiRequest();

  const [isLoading, setIsLoading] = useState(true);
  const [metaResponse, setMetaResponse] = useState<KpiDashboardMetaResponseDto>();

  const fetchMeta = useCallback(async () => {
    setIsLoading(true);
    try {
      const response = await apiRequest<KpiDashboardMetaResponseDto>(`kpi-dashboards/meta/${DASHBOARD_KEY}`, 'GET');
      if (response.data) setMetaResponse(response.data);
    } catch (error) {
      console.error('Error fetching meta data:', error);
    } finally {
      setIsLoading(false);
    }
  }, [apiRequest]);

  useEffect(() => {
    if (!user || user.userType !== UserType.Internal || user.userRole === UserRole.User) {
      navigate('/', { replace: true });
      return;
    }

    fetchMeta();
  }, [user, navigate, fetchMeta]);

  return (
    <div className="flex flex-col gap-5 h-full">
      <DataFetchParent
        data={metaResponse}
        renderElement={(data: KpiDashboardMetaResponseDto) => <KpiDashboardPage kpiDashboardMeta={data} />}
        isLoading={isLoading}
      />
    </div>
  );
};

export default KpiDashboardWrapper;
